module.exports = __webpack_public_path__ + "static/media/Emptymodule.28785074.svg";